import React from 'react';
import Img from "../../images/services/ec/ecommerce.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Turnkey E-Commerce Services</h2>
                        <p>Your online store idea needs the right ecommerce services, technical expertise, and two
                            factors to succeed: a sustainable business model and an alpha team for the right execution.
                            Witness first-hand in our project portfolio.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;